export const RETRO_CONFLUENCE_CROSS_FLOW_SOURCE = 'Retro';
export const JIRA_ISSUE_CREATE_CONTENT_CONFLUENCE_CROSS_FLOW_SOURCE = 'JiraIssueCreateContent';
